import { render, staticRenderFns } from "./CreateExtraModal.vue?vue&type=template&id=290d053a&"
import script from "./CreateExtraModal.vue?vue&type=script&lang=js&"
export * from "./CreateExtraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports